import { combineReducers } from 'redux';

import { HIDE_CREATE_TEMPLATE_MODAL, OPEN_CREATE_TEMPLATE_MODAL, SET_SEARCH, SET_SORT } from 'modules/groupTemplates/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *   sort: string,
 *   search: string,
 *   creationModal: boolean
 * }} GroupTemplatesUiDashboardState
 */

/**
 * @typedef {{
 *   dashboard: GroupTemplatesUiDashboardState,
 * }} GroupTemplatesUiState
 */

export default combineReducers({
  dashboard: combineReducers({
    sort: createReducer('name,asc', {
      [SET_SORT]: (_, { payload }) => payload,
    }),
    search: createReducer('', {
      [SET_SEARCH]: (_, { payload }) => payload,
    }),
    creationModal: createReducer(false, {
      [OPEN_CREATE_TEMPLATE_MODAL]: () => true,
      [HIDE_CREATE_TEMPLATE_MODAL]: () => false,
      [LOCATION_CHANGE]: () => false,
    })
  }),
});
